var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"headline mt-3 text-center"},[_vm._v("Kanaljämförelse - Nordic Entertainment Group")]),_c('chart',{staticClass:"mt-3",on:{"data:loaded":_vm.dataLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }